<template lang="pug">
#modal-visualizar-detalhes-alerta
    el-dialog.custom-dialog(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='45%',
        v-loading='isLoading'
    )
        template(slot='title')
            .dialog-header
                | Alertas encontrados no monitoramento
            p.title
                | Visualizar pelo período de detecção
            el-radio-group.radio-group-container(
                v-model='radio',
                @change='buscarAlertaAgricola'
            )
                el-radio.radio-spacing(:label='"hoje"')
                    | Hoje
                el-radio.radio-spacing(:label='"seteDias"')
                    | Últimos 7 dias
                el-radio.radio-spacing(:label='"trintaDias"')
                    | Últimos 30 dias
                el-radio.radio-spacing(:label='"todoPeriodo"')
                    | Todo o período
        .empty(v-if='dados?.agricola?.length < 1')
            el-empty(
                description='Você não possui alertas no período de detecção selecionado'
            )
        .content(v-else)
            .alert-container(v-for='(alerta, index) in dados?.agricola')
                .margin-left
                    p.alert-title
                        | {{ mapToPhrase(alerta.tipoAlertaAgricola) }}
                    p.alert-description
                        | {{ alerta.descricao }}
                    .alert-footer
                        p.footer-label Data do alerta:
                        span {{ alerta.dataCadastro }}
                el-divider.custom-divider(
                    v-if='index < dados?.agricola?.length - 1'
                )
        el-divider.custom-divider
        footer(slot='footer')
            el-button.margin-top(
                @click='fecharModalAlertaDetalhes()',
                size='big',
                type='primary'
            )
                | Voltar
</template>

<script>
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';

export default {
    name: 'ModalVisualizarDetalhesAlerta',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        codigoAreaMonitorada: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
            radio: 'hoje',
            pageParams: {
                page: 1,
                size: 100
            },
            filtro: {
                codigoAreaMonitorada: null,
                idGrupos: null,
                codigoTipoOperacao: null,
                camadas: null,
                codigoCar: null,
                tipoAlertaAgricola: null,
                dataCadastroInicial: null,
                dataCadastroFinal: null
            },
            dados: {}
        };
    },

    mounted() {
        this.buscarAlertaAgricola();
    },

    methods: {
        fecharModalAlertaDetalhes() {
            this.$emit('voltar');
        },

        async buscarAlertaAgricola() {
            this.isLoading = true;
            let today = new Date();

            this.filtro.codigoAreaMonitorada = this.codigoAreaMonitorada;

            switch (this.radio) {
                case 'hoje':
                    this.filtro.dataCadastroInicial = today;
                    this.filtro.dataCadastroFinal = today;
                    break;
                case 'seteDias':
                    let sevenDaysAgo = new Date();
                    sevenDaysAgo.setDate(today.getDate() - 7);
                    this.filtro.dataCadastroInicial = sevenDaysAgo;
                    this.filtro.dataCadastroFinal = today;
                    break;
                case 'trintaDias':
                    let thirtyDaysAgo = new Date();
                    thirtyDaysAgo.setDate(today.getDate() - 30);
                    this.filtro.dataCadastroInicial = thirtyDaysAgo;
                    this.filtro.dataCadastroFinal = today;
                    break;
                case 'todoPeriodo':
                    this.filtro.dataCadastroInicial = null;
                    this.filtro.dataCadastroFinal = null;
                    break;
            }

            try {
                const { data } =
                    await await MonitoramentoAgricolaService.buscarAlertaAgricola(
                        this.filtro,
                        this.pageParams
                    );

                this.dados = data;
            } catch (error) {
                this.$notify.error(
                    'Não foi possivel carregar os dados detalhados de alertas.'
                );
            } finally {
                this.isLoading = false;
            }
        },
        mapToPhrase(input) {
            switch (input) {
                case 'DIVERGENCIA_PLANTIO':
                    return 'Divergência de Plantio';
                case 'DIVERGENCIA_AREA_PLANTADA':
                    return 'Divergência de Área Plantada';
                case 'DIVERGENCIA_CULTURA':
                    return 'Divergência de Cultura';
                case 'DIVERGENCIA_PRODUTIVIDADE':
                    return 'Divergência de Produtividade';
                case 'DIVERGENCIA_COLHEITA_POR_CULTURA':
                    return 'Divergência de Colheita por Cultura';
                default:
                    return input;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-visualizar-detalhes-alerta {
    ::v-deep .el-dialog__body {
        padding: 0px;
    }

    .content {
        overflow: auto;
        max-height: 250px;
    }

    .margin-top {
        margin-top: 16px;
    }

    .margin-left {
        margin-left: 20px;
    }

    .custom-cursor {
        cursor: pointer;
    }

    .alert-container {
        line-height: 1rem;
    }

    .alert-footer {
        display: flex;
    }

    .footer-label {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-right: 5px;
        font-size: 13.5px;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border-color: blue !important;
        background-color: blue !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner::after {
        border-color: blue !important;
        background-color: blue !important;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-divider {
        margin-bottom: -10px;
        margin-top: 5px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .radio-group-container {
        max-width: 510px;
        height: 10px;
        display: flex;
        justify-content: space-between;
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
        font-family: 'Roboto', 'sans serif';
    }

    .radio-spacing {
        margin-right: 10px;
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .custom-dialog {
        border-radius: 5px;
    }

    footer {
        display: flex;
        justify-content: flex-end;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .view-title {
        margin-left: 15px;
        font-family: 'Roboto', 'sans serif';
        font-size: 16px;
        font-weight: 500;
    }

    .title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
    }

    .alert-title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-top: 35px;
    }

    .alert-description {
        font-family: 'Roboto', 'sans serif';
        color: #000000;
        font-weight: 300;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }
}
</style>
